import { render, staticRenderFns } from "./ChatRecommendedV2.vue?vue&type=template&id=7cc2c72a&scoped=true"
import script from "./ChatRecommendedV2.vue?vue&type=script&lang=js"
export * from "./ChatRecommendedV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc2c72a",
  null
  
)

export default component.exports